// Environment-aware authentication configuration
// Automatically selects the correct config based on environment

// Import both configs
import { amplifyConfig as prodConfig, apiConfig as prodApiConfig } from './auth';
import { amplifyConfig as devConfig, apiConfig as devApiConfig } from './auth.dev';

// Determine environment
// Vite uses import.meta.env instead of process.env
const isDev = import.meta.env.VITE_APP_ENV === 'dev' || 
              import.meta.env.MODE === 'development-dev' ||
              window.location.hostname.includes('dev.mockmcp.com');

// Export the appropriate config based on environment
export const amplifyConfig = isDev ? devConfig : prodConfig;
export const apiConfig = isDev ? devApiConfig : prodApiConfig;
